import React from 'react';
import journeyImage from '../../../assets/images/Defence/Support/journey.jpg';

/* ================================
   JOURNEY SECTION STYLES
================================ */
const journeyStyles = `
/* SECTION */
.journey-section {
  width: 100%;
  background: #ffffff;
  padding: 0 0 0;
}

/* CONTAINER */
.journey-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 40px 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 80px;
}

/* LEFT CONTENT */
.journey-left {
  flex: 1;
  max-width: 520px;
}

.journey-left h2 {
  font-size: 36px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 20px;
}

.journey-left p {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.7;
  color: #475569;
}

/* RIGHT IMAGE */
.journey-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.journey-right img {
  width: 100%;
  max-width: 600px;
  border-radius: 18px;
  object-fit: cover;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.25);
}

/* CTA STRIP */
.journey-cta {
  width: 100%;
  background: linear-gradient(135deg, #fff7ed, #ffedd5);
  padding: 80px 20px;
  text-align: center;
}

/* CTA TEXT */
.journey-cta h3 {
  font-size: 42px;
  font-weight: 700;
  color: #3b3b3b;
  max-width: 700px;
  margin: 0 auto 16px;
  line-height: 1.3;
}

.journey-cta p {
  font-size: 18px;
  font-weight: 400;
  color: #475569;
  margin-bottom: 40px;
}

/* BUTTON */
.journey-btn {
  background: #fb923c;
  color: #ffffff;
  border: none;
  padding: 16px 40px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.journey-btn:hover {
  background: #f97316;
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(251, 146, 60, 0.4);
}

/* RESPONSIVE */
@media (max-width: 900px) {
  .journey-container {
    flex-direction: column;
    text-align: center;
  }

  .journey-left {
    max-width: 100%;
  }

  .journey-cta h3 {
    font-size: 28px;
  }
}
`;

export default function JourneySection() {
  return (
    <>
      {/* INTERNAL CSS */}
      <style>{journeyStyles}</style>

      {/* JOURNEY SECTION */}
      <section className="journey-section">
        <div className="journey-container">

          {/* LEFT */}
          <div className="journey-left">
            <h2>Our Journey</h2>
            <p>
              Founded with a vision to strengthen indigenous defense capabilities,
              Combat Solutions has steadily evolved into a reliable partner for
              defence, industrial, and medical electronics. Our growth is driven by
              technical excellence, ethical practices, and a commitment to
              innovation, enabling us to support critical systems throughout
              their operational lifecycle.
            </p>
          </div>

          {/* RIGHT */}
          <div className="journey-right">
            <img src={journeyImage} alt="Quality and standards visualization" />
          </div>

        </div>

        {/* CTA STRIP */}
        <div className="journey-cta">
          <h3>
            Reliable Support for Systems Where
            <br />
            Failure Is Not an Option
          </h3>

          <p>
            Defence-grade expertise • Indigenous capability • Long-term reliability
          </p>

       <a
  href="https://mail.google.com/mail/?view=cm&fs=1&to=defence@combatsolutions.com&su=Defence%20Support%20Inquiry&body=Hello%20Combat%20Solutions%20Team,"
  target="_blank"
  rel="noopener noreferrer"
  style={{ textDecoration: "none" }}
>
  <button className="journey-btn">
    Contact Defence Team
  </button>
</a>


        </div>
      </section>
    </>
  );
}
